import { z } from 'zod';
import { PageSchema } from './page.entity.model';

export const PageTranslateEnglishType = z.enum([
  'Title',
  'Header',
  'Description',
  'Notice',
]);
export type PageTranslateEnglishType = z.infer<typeof PageTranslateEnglishType>;

export const PageTranslateEnglishSchema = z.object({
  page: PageSchema.optional(),
  type: PageTranslateEnglishType,
  text: z.string()
});

export type PageTranslateEnglish = z.infer<typeof PageTranslateEnglishSchema>;

